import type { AxiosError } from 'axios';
import axios from 'axios';
import { FEATURE_FLAG } from 'const/session-storage';
import posthog from 'posthog-js';

import config from '../config/config';

declare const VERSION: string;

export const getFeatureFlag = async (): Promise<{ [key: string]: unknown }> => {
  const ffString = sessionStorage.getItem(FEATURE_FLAG);
  if (ffString) {
    return JSON.parse(ffString);
  }
  const apiBaseUrl = config.publicApi.enabled ? `${config.publicApi.url}` : `${config.api.url}`;
  try {
    const response = await axios.get<{
      data: { [key: string]: unknown };
    }>(`${apiBaseUrl}/api/feature-flag/`);
    const ff = response.data.data;
    sessionStorage.setItem(FEATURE_FLAG, JSON.stringify(ff));
    return ff;
  } catch (e) {
    const error = e as AxiosError;
    posthog?.capture('getFeatureFlagFailed', { error: error.toJSON(), version: VERSION });
    console.warn(`feature flag failed Error: ${(e as AxiosError).message}`);
    return {};
  }
};
